<template>
  <div>
    <span role="button" class="close float-end fs-4" @click.prevent="$emit('close')">
      <span aria-hidden="true"><i class="far fa-times"></i></span>
    </span>
    <h3 v-if="networksList.length == 1">{{ $t('Available-in-following-network') }}</h3>
    <h3 v-else>{{ $t('Available-in-following-networks') }} ({{ networksList.length }})</h3>
    <hr />
    <p v-for="network in sortedArray(networksList)" :key="network.id" style="padding: 0 0 1rem 2rem; border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
      <span>
        <a v-if="network.public || network.is_mine" :href="'/networks/' + network.slug">{{ network.name }}</a>
        <a v-else role="link" aria-disabled="true">{{ network.name }}</a>
        <div v-if="!network.public" class="badge rounded-pill bg-danger fw-bold ms-2" style="vertical-align: 2px;">
          {{ $t('network.networkForm.privateNetwork') }}
        </div>
      </span>
    </p>
  </div>
</template>
<script>
import sortBy from 'lodash/sortBy';

export default {
  props: {
    networksList: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    sortedArray(array) {
      return sortBy(array, 'name');
    },
  },
};
</script>
